import * as ActionTypes from "constants/ActionTypes";
import deepEqual from "deep-equal";
import { combineReducers } from "redux";

function dimensions(state = { height: 0, width: 0 }, action) {
  let potentialNewDimensions;

  switch (action.type) {
    case ActionTypes.SET_VIEWPORT_DIMENSIONS:
      potentialNewDimensions = {
        height: action.dimensions.height,
        width: action.dimensions.width,
      };

      if (deepEqual(potentialNewDimensions, state)) {
        // Return the original state if this call doesn't change it
        return state;
      }

      return potentialNewDimensions;
    default:
      return state;
  }
}

function pixelRatio(state = 1, action) {
  switch (action.type) {
    case ActionTypes.SET_VIEWPORT_PIXEL_RATIO:
      return action.pixelRatio;
    default:
      return state;
  }
}

export default combineReducers({
  dimensions,
  pixelRatio,
});
